import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const employeeDetailService = (userSeq) => {
  return axiosInstance
    .get(`${ENDPOINTS.ADMIN.EMPLOYEE_MANAGEMENT.DETAIL}/${userSeq}`)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
